import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { FinzyService } from 'src/app/core/services/finzy.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-e-sign',
  templateUrl: './e-sign.component.html',
  styleUrl: './e-sign.component.scss'
})
export class ESignComponent {
  constructor(private spinner: NgxSpinnerService, private finzyService: FinzyService, private route: ActivatedRoute, private router: Router) { }
  ngOnInit(): void {
    this.spinner.hide();

    this.route.queryParamMap.subscribe(async params => {
      const status = params.get('status');
      const transId = params.get('digio_doc_id');

      if (status === 'success' && transId) {
        this.spinner.show();
        var res = await lastValueFrom(this.finzyService.UpdateEsign({ status: status, documentId: transId }));
        if (res['data'] === "success") {
          this.spinner.hide();
          return this.router.navigateByUrl('/assist-journey/f/e-mandate');
        }
      }
    });
  }

  async startEAgreementSign() {
    try {
      var res = await lastValueFrom(this.finzyService.InitiateESign());
      if (res['data']) {
        window.location.href = res['data'];
      }
      else {
        this.spinner.hide();
        swal.fire('Error', 'Error initiating E-Sign. Please try again later.');
      }
    } catch (err) {
      if (err.status === 0) {
        swal.fire('Error', 'Network Error: Please check your internet connection and try again.');
        return;
      }

      if (err?.status === 401) {
        this.spinner.hide();
        this.router.navigateByUrl('/assist-journey/session-expired');
      }
    }
  }
}